import { styled } from '@/stitches.config';
import { ReactComponent as RightArrowIcon } from '@assets/icons/arrow-right.svg';
import { Box } from '@base-app';
import { CSSProperties } from '@stitches/react';

export const StyledRightArrowIcon = styled(RightArrowIcon, {});

export const StyledDateContainer = styled(Box, {
  display: 'flex',
  alignItems: 'center',
});

export const StyledSubPageHeaderContainer = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '$7',
  width: '100%',
  variants: {
    isSticky: {
      true: {
        alignItems: 'center',
        backgroundColor: '$white',
        borderBottom: '$borderWidths$1 solid $grey200',
        boxShadow: '$stickyNav',
        display: 'flex',
        height: '$stickyNav$height',
        justifyContent: 'space-evenly',
        left: '0',
        margin: '0',
        overflow: 'visible',
        paddingLeft: '$studyInsights$sidebarWidthClose',
        position: 'fixed',
        transition: 'top 400ms ease-in-out 0s',
        width: '100%',
        zIndex: '$stickyHeader',
      },
    },
  },
});

export const StyledSelectedRange = styled(Box, {
  alignItems: 'center',
  color: '$darkBlue200',
  display: 'flex',
  fontSize: '$4',
  fontWeight: '$regular',
  lineHeight: '$6',
});

export const StyledDate = styled(Box, {
  marginLeft: '$4',
  fontWeight: '$bold',
  lineHeight: '$6',
});

export const StyledSelectContainer = styled(Box, {
  marginLeft: '$4',
});

export const loaderStyles: CSSProperties = {
  height: '520px',
  padding: '24px',
};
